(() => {
  const HOLDER_SELECTOR = '[id="CartDrawerRecommendations"]';
  const LIMIT = 12;
  const RECS_URL = '/recommendations/products';           // hard-code for reliability
  const FALLBACK_COLL = 'ymi-best-sellers';
  const RETRY_DELAY = 200;                                // ms between cart.js retries
  const MAX_RETRIES = 6;

  const buildRecUrl = pid =>
    `${RECS_URL}?product_id=${pid}&limit=${LIMIT}&intent=related&section_id=product-recommendations`;

  const formatPrice = m =>
    (Number(m) > 1000 ? m / 100 : Number(m))
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  const productCard = p => {
    const img = p.images?.[0]?.src
      ? p.images[0].src.replace(/(\.[a-z]+)(\?.*)?$/, '_400x$1')
      : '//cdn.shopify.com/s/assets/no-image-400x.gif';
    return `
      <div class="grid__item grid-product small--one-half medium-up--one-quarter"
           data-product-id="${p.id}" data-product-handle="${p.handle}">
        <a href="/products/${p.handle}" class="grid-product__link">
          <div class="grid-product__image-mask">
            <button class="product-actions__quick-add quick-product__btn--not-ready js-modal-open-quick-modal js-modal-open-quick-modal-${p.id}" type="button"></button>
            <div class="image-wrap"><img src="${img}" alt="${p.title}" loading="lazy"></div>
          </div>
        </a>
        <div class="grid-product__meta">
          <div class="grid-product__title">${p.title}</div>
          <div class="grid-product__price">${formatPrice(p.variants[0].price)}</div>
        </div>
      </div>`;
  };

  const fetchFallback = async () => {
    const r = await fetch(`/collections/${FALLBACK_COLL}/products.json?limit=${LIMIT}`).then(x => x.json());
    const products = r.products || [];
    return { html: products.map(productCard).join(''), products };
  };

  const renderQuickShopModals = products => {
    const wrap = document.createElement('div');
    products.forEach(p => {
      wrap.innerHTML += `<div id="QuickShopModal-${p.id}" class="modal modal--quick-shop" data-product-id="${p.id}">
        <div class="modal__inner"><div class="modal__centered"><div class="modal__centered-content">
          <button type="button" class="modal__close js-modal-close text-link desktop-close-only">✕</button>
          <div id="QuickShopHolder-${p.handle}"></div>
        </div></div></div></div>`;
    });
    document.body.appendChild(wrap);
  };

  const injectBlock = (holder, title, markup, products = []) => {
    holder.innerHTML = `<div class="header-part">${title}</div>
                        <div class="product-part" data-event="open">${markup}</div>`;
    if (products.length) renderQuickShopModals(products);
    theme?.initQuickShop?.();
  };

  const renderHolder = async (holder, pid) => {
    holder.innerHTML = '';
    const recUrl = pid ? buildRecUrl(pid) : null;

    if (recUrl) {
      try {
        const html = await fetch(recUrl).then(r => r.text());
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const recs = tmp.querySelector('.product-recommendations');
        if (recs && recs.innerHTML.trim()) {
          injectBlock(holder, 'Frequently Bought Together', recs.innerHTML);
          return;
        }
      } catch {/* fall through to fallback */}
    }

    const { html, products } = await fetchFallback();
    if (html) injectBlock(holder, 'Best Sellers', html, products);
  };

  const loadProductIdWithRetry = async () => {
    for (let i = 0; i < MAX_RETRIES; i++) {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (cart.items?.[0]?.product_id) return cart.items[0].product_id;
      } catch {}
      await new Promise(res => setTimeout(res, RETRY_DELAY));
    }
    return null;
  };

  const renderAll = async () => {
    const holders = [...document.querySelectorAll(HOLDER_SELECTOR)];
    if (!holders.length) return;
    const pid = await loadProductIdWithRetry();
    holders.forEach(h => renderHolder(h, pid));
  };

  /* fire on drawer open */
  new MutationObserver(() => {
    if (document.body.classList.contains('drawer--is-open')) renderAll();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* fire after any cart-affecting fetch */
  const origFetch = window.fetch;
  window.fetch = async (...a) => {
    const resp = await origFetch(...a);
    const url = typeof a[0] === 'string' ? a[0] : a[0].url;
    if (/\/cart\/(add|change|update)(\.js)?/i.test(url)) renderAll();
    return resp;
  };

  document.addEventListener('DOMContentLoaded', renderAll);
})();
